import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { FingerprintJSPro, FpjsProvider } from "@fingerprintjs/fingerprintjs-pro-react";
/**
 * Internal wrapper that only initializes FingerprintJS when AnySpend components are actually used.
 * This prevents unnecessary fingerprinting of users who don't interact with AnySpend.
 */
export function AnySpendFingerprintWrapper({ children, fingerprint }) {
    // If no fingerprint config is provided, render children without fingerprinting
    if (!fingerprint?.apiKey) {
        console.warn("No Fingerprint API key provided. Fingerprinting will be disabled.");
        return _jsx(_Fragment, { children: children });
    }
    // Ensure endpoint has https:// prefix
    const endpoint = fingerprint.endpoint && !fingerprint.endpoint.startsWith("http")
        ? `https://${fingerprint.endpoint}`
        : fingerprint.endpoint;
    return (_jsx(FpjsProvider, { loadOptions: {
            apiKey: fingerprint.apiKey,
            endpoint: endpoint ? [endpoint, FingerprintJSPro.defaultEndpoint] : undefined,
            scriptUrlPattern: fingerprint.scriptUrlPattern
                ? [fingerprint.scriptUrlPattern, FingerprintJSPro.defaultScriptUrlPattern]
                : undefined,
        }, children: children }));
}
const defaultApiKey = "80EnsS6POsxPAR9xGxmN";
// Helper function to get fingerprint config from environment variables
export function getFingerprintConfig() {
    return {
        apiKey: process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY || defaultApiKey,
        endpoint: process.env.NEXT_PUBLIC_FINGERPRINT_ENDPOINT,
        scriptUrlPattern: process.env.NEXT_PUBLIC_FINGERPRINT_SCRIPT_URL,
    };
}
